var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementCommentArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5816 12.6544L4.74585 21.5224C4.61262 21.597 4.4598 21.6292 4.30781 21.6146C4.15582 21.6 4.0119 21.5394 3.89528 21.4409C3.77866 21.3423 3.6949 21.2105 3.65519 21.0631C3.61549 20.9156 3.62173 20.7596 3.67309 20.6158L6.66006 12.2523C6.71832 12.0891 6.71832 11.9109 6.66006 11.7478L3.67309 3.38423C3.62173 3.24044 3.61549 3.08439 3.65519 2.93696C3.6949 2.78952 3.77866 2.65771 3.89528 2.55915C4.0119 2.46059 4.15582 2.39998 4.30781 2.3854C4.45981 2.37083 4.61263 2.403 4.74585 2.4776L20.5816 11.3456C20.6979 11.4108 20.7948 11.5057 20.8622 11.6208C20.9296 11.7358 20.9652 11.8667 20.9652 12C20.9652 12.1333 20.9296 12.2642 20.8622 12.3793C20.7948 12.4943 20.6979 12.5892 20.5816 12.6544V12.6544Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12H12.75",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementCommentArrow);
export default __webpack_public_path__ + "static/media/AnnouncementCommentArrow.58f91d6f.svg";
export { ForwardRef as ReactComponent };